/**
 * The web build's own identity (CD-010 / LP-032), injected by vite.config.ts.
 * Guarded so a test runner without the define still loads the module.
 */
export interface BuildInfo {
  version: string;
  /** The publish run's number (CD-018), e.g. "20" or "21 review". */
  build: string | null;
  commit: string | null;
  tag: string | null;
  builtAt: string | null;
}

export const WEB_BUILD: BuildInfo =
  typeof __APP_BUILD__ !== "undefined"
    ? __APP_BUILD__
    : { version: "dev", build: null, commit: null, tag: null, builtAt: null };
